// src/components/LevelIcon.tsx
import React from 'react';
import { UserLevel } from '../types/xp';

const LEVEL_ICONS: Record<UserLevel, string> = {
  explorer: '🌱',
  novice: '⭐',
  developer: '💫',
  strategist: '🌟',
  master: '🏆',
  virtuoso: '👑',
  sage: '🔮',
  legend: '⚡'
};

export const LevelIcon = ({ level }: { level: UserLevel }) => (
  <span title={`Level: ${level}`} className="text-xl">
    {LEVEL_ICONS[level]}
  </span>
);